// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1376":"234b7f3b4854461f","4949":"15c19f2d596258cf","62574":"f66d4429738d4ece","82274":"3f45e1fa8fbf02ee","91474":"62a0a9f1d21f03a3","97271":"b2206fd4b887cb0f"}[chunkId] + ".css";
};